/*
 *  @providesModule GeocomplyController
 *
 */

const LOCATION_CACHE_KEY = 'LOCATION_CACHE_KEY';

let cachedPromise: Promise<string> | null = null;

export const getGeoPacket = async (reason?: string): Promise<string> => {
  if (cachedPromise) {
    return cachedPromise;
  }
  cachedPromise = getGeoLocationString(reason).finally(() => {
    cachedPromise = null;
  });
  return cachedPromise;
};

function getGeoLocationString(reason?: string): Promise<string> {
  return new Promise((resolve, reject) => {
    let error = null;

    const locationData = JSON.parse(localStorage.getItem(LOCATION_CACHE_KEY) || '{}');
    if (locationData.geopacket) {
      return resolve(locationData.geopacket);
    }

    if (!window.geoClient) {
      return reject('Package not installed');
    }
    if (reason) {
      window.geoClient.setReason(reason);
    }

    window.geoClient.events.on('*.failed', function (code, message) {
      error = message;
    });

    window.geoClient.events.on('success', (text) => {
      if (error) {
        reject(error);
      } else {
        localStorage.setItem(
          LOCATION_CACHE_KEY,
          JSON.stringify({
            geopacket: text,
          })
        );
        resolve(text);
      }
    });

    window.geoClient.request();
  });
}

export const resetGeoPacket = (): Promise<string> => {
  localStorage.removeItem(LOCATION_CACHE_KEY);
  return getGeoPacket();
};
